import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/(auth)/error.tsx");
